import React from 'react';
import { Link } from 'react-router-dom';

export default function TarotLottoBridge({ reading, onSearchNumber }) {
  if (!reading) return null;

  const { luckyNumbers, primaryDream, positions } = reading;

  return (
    <section className="tarot-lotto-bridge" aria-labelledby="tarot-lotto-heading">
      <h2 id="tarot-lotto-heading" className="tarot-lotto-bridge__title">
        ✨ เชื่อมไพ่กับเลขเด็ด Hotto
      </h2>
      <p className="tarot-lotto-bridge__desc">
        เลขจากพลังไพ่และสถิติหวย 32 ปี — คลิกเพื่อเช็คทันที
      </p>

      <div className="tarot-lotto-bridge__numbers">
        <p className="tarot-lotto-bridge__label">เลขนำโชคจากไพ่</p>
        <div className="tarot-lotto-bridge__chips">
          {luckyNumbers.map((num) => (
            <Link
              key={num}
              to={`/search/${encodeURIComponent(num)}`}
              className="tarot-lotto-bridge__chip"
              onClick={() => onSearchNumber?.(num)}
            >
              {num}
            </Link>
          ))}
        </div>
      </div>

      {primaryDream && (
        <div className="tarot-lotto-bridge__dream">
          <p className="tarot-lotto-bridge__label">คำทำนายที่สอดคล้อง</p>
          <Link
            to={`/search/${encodeURIComponent(primaryDream)}`}
            className="tarot-lotto-bridge__dream-link"
          >
            ค้นหา &ldquo;{primaryDream}&rdquo; → เลขเด็ดจากฝัน
          </Link>
        </div>
      )}

      <div className="tarot-lotto-bridge__cards-ref">
        {positions.map((p) => (
          <p key={p.key} className="tarot-lotto-bridge__ref-line">
            <strong>{p.labelTh}</strong> {p.card.nameTh} → เลข {p.card.luckyDigits.join(', ')}
          </p>
        ))}
      </div>

      <Link to="/#hints" className="tarot-lotto-bridge__cta">
        ดูเลขเด็ดงวดนี้ (คำชะโนด · ปฏิทินจีน) →
      </Link>
    </section>
  );
}
